import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {VehiclesService} from '../../../data/vehicles/vehicles.service';
import {VehicleCategoryModel} from '../../models/vehicle';
import {MultiSelectComponent, MultiSelectFilter} from '../multi-select-component';
import {ToastService} from '../../services/toast.service';
import {MatCheckbox} from '@angular/material/checkbox';
import {MatDivider} from '@angular/material/divider';
import {MatButton} from '@angular/material/button';

/**
 * This component allows to create a multi-select filter of Vehicle Group entities.
 * It either emits 'undefined' value if no filter is set or an array of entities.
 *
 * In addition, it saves the state of the filter to URL params and browser's storage.
 */

@Component({
  selector: 'app-vehicle-group-filter',
  templateUrl: './vehicle-group-filter.component.html',
  styleUrls: ['./vehicle-group-filter.component.scss'],
  imports: [
    MatCheckbox,
    MatDivider,
    MatButton
  ]
})
export class VehicleGroupFilterComponent extends MultiSelectComponent<VehicleCategoryModel> implements OnInit {

  SETTINGS_KEY = 'selectedVehicleGroupIds';
  USE_FULLY_CHECKED_AS_DEFAULT = false;

  @Input() origin;
  @Output() filterChanged = new EventEmitter<MultiSelectFilter<VehicleCategoryModel>>();

  constructor(
      private readonly vehicleService: VehiclesService,
      private readonly toast: ToastService,
  ) {
    super();
  }

  ngOnInit() {
    this.vehicleService.getVehicleCategories().then(response => {
      this.initComponent(response);
    }).catch(error => {
      console.log(error);
      this.toast.longer('Error while loading vehicle groups!');
    });
  }

  getLabel(item: VehicleCategoryModel): string {
    return item.title || item.name;
  }

  onApply() {}

}
